import ReactGA from 'react-ga4';

// Ersetzen Sie 'G-EZ42BVGLFD' mit Ihrer tatsächlichen Google Analytics 4 Measurement ID
const MEASUREMENT_ID = 'G-EZ42BVGLFD';

// Prüft, ob Analytics aktiviert ist
const isAnalyticsEnabled = (): boolean => {
  const cookieSettings = localStorage.getItem('cookieSettings');
  if (cookieSettings) {
    try {
      const settings = JSON.parse(cookieSettings);
      return settings.analytics === true;
    } catch (e) {
      return false;
    }
  }
  return false;
};

// Initialisierungsfunktion
export const initGA = () => {
  if (process.env.NODE_ENV === 'production' && isAnalyticsEnabled()) {
    ReactGA.initialize(MEASUREMENT_ID);
  }
};

// Funktion zum Aktualisieren des Analytics-Status
export const updateAnalyticsStatus = () => {
  if (process.env.NODE_ENV === 'production') {
    if (isAnalyticsEnabled()) {
      // Wenn Analytics aktiviert wurde, initialisieren
      ReactGA.initialize(MEASUREMENT_ID);
    } else {
      // Wenn Analytics deaktiviert wurde, GA-Cookies löschen
      // Hier können wir leider nicht direkt GA deaktivieren, aber wir können
      // sicherstellen, dass keine neuen Tracking-Daten gesendet werden
    }
  }
};

// Funktion zum Tracken von Seitenaufrufen
export const trackPageView = (path: string) => {
  if (process.env.NODE_ENV === 'production' && isAnalyticsEnabled()) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

// Funktion zum Tracken von Ereignissen
export const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  if (process.env.NODE_ENV === 'production' && isAnalyticsEnabled()) {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
  }
};
